import CONSTANTS from "src/constants";

export const isProd = () => {
    const isDev = CONSTANTS.DEV;
    const isStaging = window.location.hostname.includes("staging.liveheats");
    return !isDev && !isStaging;
}
